import { useContextState } from "../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        arrowHeaderDrawerContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            padding: '10px 20px 0',
            '& .quest-name-header': {
                fontSize: '14px',
                color: colors.color1,
                fontWeight: '500',
            },
        },
        closeSettings: {
            fontSize: '1.2rem',
            color: colors.color1,
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
        },
    }
}

export { useStyles }